import React, { useState } from 'react';
import styled from 'styled-components';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

const IMAGES = [
  { src: '/assets/JerseyModelBack.jpg' },
  // This photo carries the wordmark edge to edge, so show it whole instead of cropping it square
  { src: '/assets/JerseyTemple1.jpg', fit: 'contain' },
  { src: '/assets/JerseyTemple2.jpg' },
  { src: '/assets/JerseyModelSeated.jpg' }
];

const PageContainer = styled.div`
  display: flex;
  min-height: calc(100vh - 100px); /* Adjust based on header height */
  padding: 40px 60px;
  align-items: center;
  justify-content: center;
  gap: 60px;
  max-width: 1400px;
  margin: 0 auto;

  @media (max-width: 968px) {
    flex-direction: column;
    padding: 30px;
    gap: 40px;
  }
`;

const LeftSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const CarouselContainer = styled.div`
  width: 100%;
  max-width: 500px;
  aspect-ratio: 1 / 1;
  border: 2px solid #000;
  position: relative;
  overflow: hidden;
  margin-bottom: 24px;
`;

const SlideImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(${props => props.$bg});
  background-size: ${props => props.$fit || 'cover'};
  background-color: #14100f;
  background-position: center;
  background-repeat: no-repeat;
  opacity: ${props => props.$active ? 1 : 0};
  transition: opacity 0.5s ease-in-out;
`;

const ControlsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  width: 100%;
  max-width: 500px;
`;

const NavButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  color: #333;
  transition: color 0.2s ease, transform 0.2s ease;

  &:hover {
    color: #000;
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.95);
  }
`;

const CaptionText = styled.div`
  text-align: center;
  font-size: 1.5rem;
  font-family: 'Cursive Nice N New', cursive; /* Using the font seen in index.css */
  color: #000;
`;

const RightSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 600px;
`;

const TextParagraph = styled.p`
  font-family: 'Catchy Mager', sans-serif;
  font-size: 1.2rem;
  line-height: 1.6;
  margin-bottom: 24px;
  color: #333;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const DefinitionGroup = styled.div`
  margin-bottom: 40px;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
`;

const WordDisplay = styled.h2`
  font-size: 2.8rem;
  font-weight: 200;
  margin: 0 0 4px 0;
  color: #111;
  letter-spacing: 0.05em;
  text-transform: lowercase;
`;

const PhoneticDisplay = styled.div`
  font-family: 'Courier New', Courier, monospace;
  font-size: 0.95rem;
  color: #777;
  margin-bottom: 16px;
  letter-spacing: 0.05em;
`;

const MeaningDisplay = styled.p`
  font-size: 1.15rem;
  line-height: 1.5;
  color: #222;
  margin: 0;
  padding-left: 18px;
  border-left: 1px solid #000;
  font-style: italic;
`;

const Home = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % IMAGES.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + IMAGES.length) % IMAGES.length);
  };

  return (
    <PageContainer>
      <LeftSection>
        <CarouselContainer>
          {IMAGES.map((img, index) => (
            <SlideImage 
              key={img.src} 
              $bg={img.src} 
              $fit={img.fit} 
              $active={index === currentIndex} 
            />
          ))}
        </CarouselContainer>
        <ControlsRow>
          <NavButton onClick={prevSlide} aria-label="Previous image">
            <FiChevronLeft size={24} />
          </NavButton>
          <CaptionText>Sprezzatura</CaptionText>
          <NavButton onClick={nextSlide} aria-label="Next image">
            <FiChevronRight size={24} />
          </NavButton>
        </ControlsRow>
      </LeftSection>
      
      <RightSection>
        <DefinitionGroup>
          <WordDisplay>sprez-za-tu-ra</WordDisplay>
          <PhoneticDisplay>/spretse't(y)oore/</PhoneticDisplay>
          <MeaningDisplay>
            — a certain nonchalance, so as to conceal all art and make whatever one does or says appear to be without effort and almost without any thought about it
          </MeaningDisplay>
        </DefinitionGroup>
        <TextParagraph>
          Introducing the Knit Soccer Jersey, our first statement piece. Made in Italy from 100% premium cotton knit, with an embroidered crest and ribbed hems.
        </TextParagraph>
      </RightSection>
    </PageContainer>
  );
};

export default Home;
